import { PageOptionsDto } from "../../../Shared/dto/page.options.dto";
import { HttpService } from "../../../Shared/Utils/HttpService";

export class ActivityService {
  static async getById(userId: string) {
    return await HttpService.request({
      url: `/activities/${userId}`,
      method: "GET",
      contentType: "json",
    });
  }

  static async delete(userId: string) {
    return await HttpService.request({
      url: `/activities/${userId}`,
      method: "DELETE",
      contentType: "json",
    });
  }

  static async getAll(pageOptions: PageOptionsDto) {
    const queryParams = new URLSearchParams({
      order: pageOptions.order || "DESC",
      page: pageOptions.page.toString(),
      query: pageOptions.query || "",
      take: pageOptions.take.toString(),
    }).toString();

    return await HttpService.request({
      url: `/activities/find?${queryParams}`,
      method: "GET",
      contentType: "json",
    });
  }

  static async findAll(findOptions: Object) {
    const query = encodeURIComponent(JSON.stringify(findOptions));
    return await HttpService.request({
      url: `/activities?findOptions=${query}`,
      method: "GET",
      contentType: "json",
    });
  }

  static async search(query: string) {
    return await HttpService.request({
      url: `/activities/search?query=${encodeURIComponent(query)}`,
      method: "GET",
      contentType: "json",
    });
  }
}
